import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Services from "@/components/landing/Services";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Videos from "@/components/landing/Videos";
import Stats from "@/components/landing/Stats";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";

export default function Landing() {
    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen bg-[#fafbfc] text-[#0a0a0a] overflow-x-hidden"
        >
            <Nav />
            <Hero />
            <BeforeAfter />
            <Videos />
            <Marquee />
            <Services />
            <Stats />
            <Process />
            <Testimonials />
            <CTA />
            <Footer />
            <FloatingActions />
        </main>
    );
}
